import styled from '@emotion/styled';
import { ProgressBar as VitaProgressBar, pxToRem } from '@modernhealth/vital-components';

const gutterPx = 24;

export const ProgressBar = styled(VitaProgressBar)({
    position: 'relative',
    margin: pxToRem(gutterPx),
    width: `calc(100% - ${2 * gutterPx}px)`,
});
